// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filter-search-with-dropdown {
  max-width: 100%;
}
.filter-search-with-dropdown__menu-title:empty {
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/search/ui/FilterSearchWithDropdownLayout.less"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AACE;EACE,UAAA;AACJ","sourcesContent":[".filter-search-with-dropdown {\n  max-width: 100%;\n\n  &__menu-title:empty {\n    padding: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
